
export default {
  xs: 0, // legacy small phone
  sm: 360, // modern small phone
  md: 768, // iPad gen 1
  lg: 1024, // iPad in landscape mode
  xl: 1440, // Macbook air 13 inch
  '2xl': 1920,
};
